/* import __COLOCATED_TEMPLATE__ from './project-create-find-freelancer-no-results.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'posting-create-find-freelancer-no-results';

class PostingCreateFindFreelancerNoResults extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      'LSG-l-grid justify-center',
    );
  }

  get className() {
    return CLASS_NAME;
  }
}

export default PostingCreateFindFreelancerNoResults;
